import scrollTo from '~scripts/core/scrollTo';

const gotoElements = document.querySelectorAll('[data-goto]');

gotoElements.forEach((gotoElement) => {
  gotoElement.addEventListener('click', (e) => {
    e.preventDefault();

    const element = e.target;
    const selector = document.querySelector(element.dataset.goto) || null;

    if (!selector) {
      throw new Error('No matched selector(s) found.');
    }

    const scrollOffset = element.dataset.offset ? +element.dataset.offset : 0;
    const scrollSpeed = element.dataset.speed ? +element.dataset.speed : 600;
    const contentRect = selector.getBoundingClientRect();
    const y = contentRect.top + window.scrollY - scrollOffset;

    if (e.target.classList.contains('js-scroll-top')) {
      scrollTo(0);
    } else {
      scrollTo(y, {
        duration: scrollSpeed,
      });
    }

    // If container we are scrolling has form
    const form = selector.getElementsByTagName('form')[0];
    const focus = element.dataset.focus;

    if (form && focus !== 'false') {
      form.elements[0].focus({ preventScroll: true });
    }
  });
});
